import { Input } from "@chakra-ui/react";
import { useField } from "@unform/core";
import { MutableRefObject } from "react";
import { useEffect } from "react";
import { useRef } from "react";

interface Props {
  name: string;
  label?: string;
  setValue?: any;
  placeholder?: string;
  as?: any;
  mask?: string;
}

type InputProps = JSX.IntrinsicElements["input"] & Props;

export default function InputForm({
  name,
  label,
  placeholder,
  required,
  setValue,
  as,
  mask,
}: InputProps) {
  type NewType = MutableRefObject<HTMLInputElement>;

  const inputRef = useRef() as NewType;
  const { fieldName, defaultValue, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,
      getValue: (ref) => {
        return inputRef.current.value;
      },
      setValue: (ref, value) => {
        ref.currency.value = value;
      },
      clearValue: (ref) => {
        ref.current.value = "";
      },
    });
  }, [fieldName, registerField]);

  return (
    <>
      {label && <label htmlFor={fieldName}>{label}</label>}
      <Input
        mb={4}
        bgColor="white"
        as={as ?? ""}
        mask={mask ?? ""}
        id={fieldName}
        placeholder={placeholder}
        value={defaultValue}
        ref={inputRef}
        required={required}
        onChange={(e) => {
          if (setValue) {
            setValue(e.target.value);
          }
        }}
      />
      {error && <span>{error}</span>}
    </>
  );
}
